import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { useDebounce } from 'use-debounce';
// api
import getAvailableFilters from '../../api/getAvailableFilters';
import moment from 'moment';
import useScrollCache from '../../context/use-scroll-cache';

// calls api to get availableFilters
const availableFiltersFetcher = async (...args) => {
  return getAvailableFilters(...args);
};

const getInitialCreatedAtAfterDate = () => {
  const today = moment();
  const initialDate = today.subtract(7, 'days');
  const formatedInitialDate = initialDate.format('YYYY-MM-DD');
  return formatedInitialDate;
};

const memoryKey = 'emergencies-filters';

const readInternalSelectedFilters = () => {
  const internalSelectedFiltersString = localStorage.getItem(memoryKey);
  try {
    const internalSelectedFilters = JSON.parse(internalSelectedFiltersString);
    return internalSelectedFilters;
  } catch (e) {
    console.error('🔥 ~ readInternalSelectedFilters e:', e);
    return null;
  }
};

// returns availableFilters with loading/reloading state
// returns selectedFilters and functions to update them
const useTicketsFilters = () => {
  const { resetScrollCache } = useScrollCache();
  const initialCreatedAtAfterDate = getInitialCreatedAtAfterDate();
  const defaultSelectedFilters = {
    search: '',
    state: '',
    created_at_after: initialCreatedAtAfterDate,
    assigned_to: '',
  };

  const initialSelectedFiltersFromStorage = readInternalSelectedFilters();

  const initialSelectedFilters =
    initialSelectedFiltersFromStorage || defaultSelectedFilters;

  const [internalSelectedFilters, setInternalSelectedFilters] = useState(
    initialSelectedFilters
  );
  const [selectedFilters] = useDebounce(internalSelectedFilters, 500);

  const availableFiltersRequestKey = 'availableFilters';

  const { data: availableFilters, error: availableFiltersError } = useSWR(
    availableFiltersRequestKey,
    availableFiltersFetcher
  );

  const isLoadingAvailableFilters = typeof availableFilters === 'undefined';

  // save filters to local storage
  useEffect(() => {
    const selectedFiltersSTRING = JSON.stringify(selectedFilters);
    localStorage.setItem(memoryKey, selectedFiltersSTRING);
    resetScrollCache();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ^^
  }, [selectedFilters]);

  const setSearch = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      search: value,
    });
  };

  const setCreatedAtAfter = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      created_at_after: value,
    });
  };

  return {
    selectedFilters,
    internalSelectedFilters,
    isLoadingAvailableFilters,
    availableFilters,
    availableFiltersError,
    setSearch,
    setCreatedAtAfter,
  };
};

export default useTicketsFilters;
